import styles from './SplashScreen.module.css';

/**
 * Full-screen loader shown while a document is authenticated, from the
 * "Grid App" design artboard: a badge, a small sheet that draws itself (frame,
 * gridlines, a few filled cells, a selection that hops between them), then the
 * wordmark with a pulsing ellipsis. `exiting` plays the fade-out; the parent
 * unmounts it once that finishes.
 */
const CELLS = [
  { className: styles.cellA, delay: '1.15s' },
  { className: styles.cellB, delay: '1.25s' },
  { className: styles.cellC, delay: '1.35s' },
  { className: styles.cellD, delay: '1.45s' },
  { className: styles.cellE, delay: '1.55s' },
];

const SplashScreen = ({ className = '', exiting = false }) => (
  <div
    className={[styles.overlay, exiting && styles.exiting, className].filter(Boolean).join(' ')}
    role="status"
    aria-busy="true"
    aria-live="polite"
    aria-label="Loading document"
  >
    <div className={styles.stack}>
      <div className={styles.badge} aria-hidden="true">
        <span className={styles.badgeCellStrong} />
        <span className={styles.badgeCell} />
        <span className={styles.badgeCell} />
        <span className={styles.badgeCellStrong} />
      </div>

      <div className={styles.canvas} aria-hidden="true">
        <div className={styles.frame} />

        <div className={`${styles.lineV} ${styles.lineV1}`} />
        <div className={`${styles.lineV} ${styles.lineV2}`} />
        <div className={`${styles.lineV} ${styles.lineV3}`} />
        <div className={`${styles.lineH} ${styles.lineH1}`} />
        <div className={`${styles.lineH} ${styles.lineH2}`} />

        {CELLS.map(({ className: cellClass, delay }) => (
          <div key={cellClass} className={`${styles.cell} ${cellClass}`} style={{ animationDelay: delay }} />
        ))}

        <div className={styles.selection} />
      </div>

      <div className={styles.wordmark}>
        <div className={styles.title}>Grid</div>
        <div className={styles.dots}>
          <span className={styles.dot} style={{ animationDelay: '0s' }} />
          <span className={styles.dot} style={{ animationDelay: '.15s' }} />
          <span className={styles.dot} style={{ animationDelay: '.3s' }} />
        </div>
      </div>
    </div>
  </div>
);

export default SplashScreen;
